<template>
  <div class="container">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section section-camara">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div id="camara-video-canvas">
        <div id="camara-video" v-show="cameraVisible">
          <video ref="video">
          </video>
          <div class="camara-button" v-show="cameraButtonVisible">
            <a @click.prevent="initScan">
              <figure>
                <img src="../../static/img/captura.png" alt="Camara">
              </figure>
            </a>   
          </div>
        </div>
        <div id="camara-canvas" v-show="!cameraVisible">
          <canvas id="camara-img" ref="canvas">
          </canvas>
          <div class="camara-button" v-show="cameraButtonVisible">
            <a @click.prevent="getVideo">
              <figure>
                <img src="../../static/img/captura.png" alt="Camara">
              </figure>
            </a>   
          </div>
        </div>
      </div>
      <!--
      <div v-show="sendVisible">
        <b-button class="link"
          @click.prevent="save">ENVIAR</b-button>
      </div>
      -->
      <!--<p>{{ imgCount + '/' + imgLimit }}</p>-->
      <p :key="estadoKey">{{ msjEstado }}</p>
      <!--
      <b-form-select 
        v-model="selectedDeviceName" 
        :options="devicesList" 
        class="mb-3">
      </b-form-select>                 
      <p>{{ (selectedDevice) ? (selectedDevice.nombre) : '' }}</p>
      -->
    </div>
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    

  </div>
</template>

<script>
import moment from 'moment';

export default {
  data () {
    return {
      evento: null,
      eventoNombre: '',
      mediaStream: null,
      cameraVisible: false,
      environmentCamara: false,
      cameraButtonVisible: false,
      torch: true,
      sendVisible: false,
      imgCount: 0,
      imgTimer: 0.5,
      imgLimit: 40,
      scanning: false,
      msjEstado: '',
      estadoKey: 0,
      error: false,
      errorMessage: '',

      selectedDevice: {},
      selectedDeviceName: '',
      devices: [],
      devicesList: [],

      participante: null,
      participanteString: ''
    }
  },
  created () {
    if (!this.$store.getters['settings/testing']) {
      if (!this.$store.getters['user/loggedIn']) {
        this.$router.push({ name: 'Login' });
      }
      
      this.evento = this.$store.getters['eventos/evento'];
      if (this.evento) {
        this.eventoNombre = this.evento.nombre;
      }

      if (!this.evento) {
        this.$router.push({ name: 'SeleccionEvento' });
      }
    }
  },
  mounted () {
    this.getDevices();
    /*this.getVideo();*/
  },
  destroyed () {
    if (this.mediaStream) {
      var tracks = this.mediaStream.getVideoTracks();
      if (tracks) {
        tracks.map (track => track.stop());
      }
    }
  },
  methods: {
    getDevices() {
      var vm = this;
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        /*console.log("enumerateDevices() not supported.");*/
        this.error = "true";
        this.errorMessage = "No se encontro una camara para la captura de datos."
        return;
      }

      var videoDevices = 0;
      vm.devices = [];
      vm.devicesList = [];
      vm.selectedDevice = null;
      vm.selectedDeviceName = '';
      this.environmentCamara = false;
      navigator.mediaDevices.enumerateDevices()
        .then(function(devices) {
          devices.forEach(function(device) {
            if (device.kind == 'videoinput') {
              videoDevices ++;

              /*console.log(device.label);*/

              var deviceData = {
                id: device.deviceId,
                nombre: (device.label) ? device.label.trim() : 'Camara ' + (videoDevices)
              }
              vm.devices.push(deviceData);
              vm.devicesList.push((device.label) ? device.label.trim() : 'Camara ' + (videoDevices));
              
              /* Agregamos la opcion del nombre por los J7 */
              if (videoDevices == 1 || device.label.toLowerCase().includes('facing back')) {
                vm.selectedDevice = deviceData;
                vm.selectedDeviceName = (device.label) ? device.label.trim() : 'Camara ' + (videoDevices);
              }
            }
          });
          if (videoDevices > 1) {
            vm.environmentCamara = true;
          }

          return;
        })
        .then(function() {
          /* Inicializamos el video */
          vm.getVideo();
        })
        .catch(function(err) {
          console.log(err.name + ": " + err.message);
        });
    },
    getVideo() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        return;
      } else {
        
        /*
        if (!this.$store.getters['settings/webCam']) {
          var constraints = { video: { 
            facingMode: { exact: "environment" }, 
            width: { ideal: 480 }, 
            height: { ideal: 640 } } };
        } else {
          var constraints = { video: { 
            width: 480, 
            height: 640 } };
        }
        */

        var constraints = { video: { 
          deviceId: { exact: this.selectedDevice.id }} };

        navigator.mediaDevices.getUserMedia(constraints)
          .then( mediaStream => {
            this.mediaStream = mediaStream;
            this.$refs.video.srcObject = mediaStream;
            this.$refs.video.play();

            this.cameraVisible = true;
            this.cameraButtonVisible = true;
            this.sendVisible = false;

            /* Recuperamos el track activo para verificar si esta disponible la lintera */
            /*
            const track = mediaStream.getVideoTracks()[0];

            this.$refs.video.addEventListener('loadedmetadata', (e) => {  
                window.setTimeout(() => (
                  onCapabilitiesReady(track.getCapabilities())
                ), 500);
              });
            */
          })
          .catch (error => {
            this.error = true;
            this.errorMessage = error;
          })
      }
    },
    setLightOn() {
      if (this.torch) {
        /* Linterna */
        /*
        const track = mediaStream.getVideoTracks()[0];
        track.applyConstraints({
          advanced: [{torch: true}]
        });
        */
      }
    },
    save () {
      if (this.participante)
      {
        this.$store.dispatch('participante/setParticipanteFromImage', this.participante)
          .then(response => {
            this.$router.push({ name: 'IngresoCelularTeclado' });
          })
          .catch( error => {
            this.error = true;
            this.errorMessage = error;
          });
      } else {
        this.error = true;
        this.errorMessage = "No se pudo recuperar la informacion del participante.";
      }
    },
    send () {
      this.$store.dispatch('participante/setParticipanteFromImage', this.participante)
        .then(response => {
          this.$router.push({ name: 'IngresoCamaraConfirmacion' });
        })
        .catch( error => {
        this.error = true;
        this.errorMessage = "Se produjo un error al registrar la informacion del participante.";
        });
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push( { name: 'Inicio' } );
    },
    initScan () {
      this.error = false;
      this.errorMessage = '';
      this.setLightOn();

      this.setDataScan()
        .then(response => {
          setTimeout(this.getImagen, 3000);
          this.scanning = true;
        })
        .catch( error => {
          console.log(error);
        });
    },
    setDataScan() {
      return new Promise((resolve, reject) => {
        /*console.log('Setting data', new Date());*/
        this.imgCount = 0;
        this.msjEstado = 'Escaneando codigo de barras';
        this.estadoKey ++;
        this.cameraButtonVisible = false;
        resolve();
      }, error => {
        reject(error);        
      });
    },
    getImagen () {
      var vm = this;

      if (this.mediaStream) {
        var context = vm.$refs.canvas.getContext('2d');
        vm.$refs.canvas.width = vm.$refs.video.videoWidth;
	      vm.$refs.canvas.height = vm.$refs.video.videoHeight;
        context.drawImage(vm.$refs.video, 0, 0, vm.$refs.canvas.width, vm.$refs.canvas.height);

        var image = context.getImageData(0, 0, vm.$refs.canvas.width, vm.$refs.canvas.height);
        var source = new ZXing.BitmapLuminanceSource(image, vm.$refs.canvas.width, vm.$refs.canvas.height);		
        var binarizer = new ZXing.Common.HybridBinarizer(source);
        var bitmap = new ZXing.BinaryBitmap(binarizer);
        var decodedString = JSON.stringify(ZXing.PDF417.PDF417Reader.decode(bitmap, null, false), null, 4);        

        if (decodedString.trim() != '[]') {
          /*
          var string = '[{"Text": "00235433070@SCHICKENDANTZ@FEDERICO@M@25608646@A@03/04/2006@01/12/2014@2019",'
          + '"RawBytes": null, "ResultPoint": [{"x": 91, "y": 240}, {"x": 88, "y": 355}],'
          + '"BarcodeFormat": 1024}]';
          var decoded = vm.getParticipanteFromImage(string);
          */

          /* Verificamos si se pudo decodificar la info (si el DNI es numerico) */
          var decoded = vm.getParticipanteFromImage(decodedString);
          if (decoded) {
            vm.sendVisible = true;
            vm.cameraVisible = !vm.cameraVisible;

            vm.$refs.video.srcObject.getVideoTracks().forEach(function (track) {
              track.stop();
            });

            vm.msjEstado = decodedString;
            vm.msjEstado = 'Código de barras detectado';
            vm.scanning = false;
            vm.send();
          }
        } else {
          /*
          var string = '[{"Text": "00235433070@SCHICKENDANTZ@FEDERICO@M@25608646@A@05/10/1976@01/12/2014@2019",'
          + '"RawBytes": null, "ResultPoint": [{"x": 91, "y": 240}, {"x": 88, "y": 355}],'
          + '"BarcodeFormat": 1024}]';
          var decoded = vm.getParticipanteFromImage(string);
          console.log(decoded);
          */

          vm.imgCount ++;
          if (vm.imgCount == vm.imgLimit) {
            vm.msjEstado = 'No se detectó un código de barras válido';
            vm.cameraButtonVisible = true;
            vm.scanning = false;
          }
        }
      }
    },
    getParticipanteFromImage(decodedString) {
      var array = JSON.parse(decodedString);
      var objectString = array[0];
      var participanteString = objectString.Text;
      var participanteArray = participanteString.split('@');

      var documentoNumero = participanteArray[4];
      if (isNaN(documentoNumero)) {
          return false;
      } 

      var fechaNacimiento = participanteArray[6];
      var dateFormat = "DD/MM/YYYY";
      var isDate = moment(fechaNacimiento, dateFormat, true).isValid();      
      if (!isDate) {
        return false;
      }

      var sexo = participanteArray[3];
      if (sexo.toLowerCase().trim() != 'm' & sexo.toLowerCase().trim() != 'f' & sexo.toLowerCase().trim() != 'x') {
        return false;
      }

      this.participante = {
        apellido: participanteArray[1],
        nombre: participanteArray[2],
        documentoNumero: documentoNumero,
        fechaNacimiento: fechaNacimiento,
        sexo: sexo
      };

      return true;
    }
  },
  watch: {
    'imgCount' : function(newVal, oldVal) {
      if (this.imgCount < this.imgLimit && this.scanning) {
        setTimeout(this.getImagen, this.imgTimer * 1000);
      }
    },    
    'selectedDeviceName' : function(newVal, oldVal) {
      if (newVal != oldVal && this.selectedDeviceName) {
        var selected = null;
        if (this.selectedDeviceName) {
          for ( let key in this.devices ){
            var device = this.devices[key];
            if (device) {
              if (device.nombre) {
                if (device.nombre.trim() == this.selectedDeviceName.trim() ){
                  selected = device;
                }
              }
            }
          }
        }
        this.selectedDevice = selected;
      }
    },    
  }   
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/IngresoCamara.vue